<app-loading-overlay [isLoading]="!!isLoading"></app-loading-overlay>
<div class="content">
  <div nz-row>
    <div nz-col nzSpan="8">
      <span class="tab-title">Schedules</span>
    </div>
    <div nz-col nzSpan="8"></div>
    <div nz-col nzSpan="8" class="scheduling-controls-div">
      <input nz-input placeholder="Search" [(ngModel)]="searchInput" (ngModelChange)="search()" />
      <button nz-button class="schedule-btn btn-gap" (click)="openCreateScheduleModal()">Create New Schedule</button>
    </div>
  </div>

  <nz-table
    #rowSelectionTable
    [nzData]="filteredData"
    [nzFrontPagination]="true"
    nzTableLayout="fixed"
    [nzPageSize]="10"
    [nzScroll]="{ x: '98.75rem', y: 'calc(100vh - 18rem)' }"
    nzSize="middle"
    nzBordered
  >
    <thead>
      <tr>
        <th nzWidth="30px"></th>
        <ng-container *ngFor="let header of headers; trackBy: trackByHeader">
          <th
            *ngIf="header.sortFn; else nonSortableHeader"
            [nzSortFn]="header.sortFn"
            [nzSortDirections]="header.sortDirections"
            [nzSortOrder]="header.sortOrder"
            [nzWidth]="header.width"
            [nzRight]="header.right"
            [class.action-header]="header.name === 'Action'"
          >
            {{ header.name }}
          </th>
          <ng-template #nonSortableHeader>
            <th [nzWidth]="header.width" [nzRight]="header.right" [class.action-header]="header.name === 'Action'">
              {{ header.name }}
            </th>
          </ng-template>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let data of rowSelectionTable.data">
        <tr>
          <td
            [nzExpand]="expandSet.has(data.schedulerId)"
            (nzExpandChange)="onExpandChange(data.schedulerId, $event)"
          ></td>
          <td>{{ data?.schedulerId }}</td>
          <td>{{ data?.name }}</td>
          <td>{{ data?.queryName }}</td>
          <td *ngIf="data?.schedulerStatus === 'Active'; else expired">
            {{ data?.nextRunOn }} {{ data?.nextRunOnSuffix }}
          </td>
          <ng-template #expired>
            <td>-</td>
          </ng-template>
          <td>{{ data?.scheduleEndsOn }}</td>
          <td>
            {{ data?.type }}
          </td>
          <td>{{ data?.createdBy }}</td>
          <td>{{ data?.createdAt | dateTime }}</td>
          <td>
            <nz-tag [nzColor]="getStatusColor(data?.schedulerStatus)">{{ data.schedulerStatus }}</nz-tag>
          </td>
          <td nzRight class="action-column">
            <div class="action-btns">
              <button
                nz-button
                nzType="text"
                aria-label="Pause Scheduler"
                *ngIf="data?.schedulerStatus === 'Active' && data?.schedulerStatus !== 'Expired'"
                (click)="updateSchedule(data)"
              >
                <span nz-icon nzType="pause" nzTheme="outline"></span>
              </button>
              <button
                nz-button
                nzType="text"
                aria-label="Active Scheduler"
                *ngIf="data?.schedulerStatus === 'Paused' && data?.schedulerStatus !== 'Expired'"
                (click)="updateSchedule(data)"
              >
                <span nz-icon nzType="caret-right" nzTheme="outline"></span>
              </button>
              <button nz-button nzType="text" aria-label="Delete Scheduler" (click)="showDeleteScheduleModal(data)">
                <span nz-icon nzType="delete" nzTheme="outline"></span>
              </button>
            </div>
          </td>
        </tr>
        <tr [nzExpand]="expandSet.has(data.schedulerId)">
          <td [attr.colspan]="headers.length + 1">
            <div class="expanded-scroll-wrapper">
              <div class="expanded-container">
                <div class="expanded-row">
                  <div></div>
                  <div [style.gridColumn]="getGridColumn(0)">
                    <p class="expanded-section-label" nz-typography>Scheduler Created On</p>
                    {{ data?.createdAt | dateTime }}
                  </div>
                  <div [style.gridColumn]="getGridColumn(3)">
                    <p class="expanded-section-label" nz-typography>Scheduler Starts On</p>
                    {{ data.startAt | dateTime }}
                  </div>
                </div>

                <div class="expanded-row">
                  <div></div>
                  <div [style.gridColumn]="getGridColumn(0)">
                    <p class="expanded-section-label" nz-typography>Last Run On</p>
                    TBD
                  </div>
                  <div [style.gridColumn]="getGridColumn(3)">
                    <p class="expanded-section-label" nz-typography>Time zone</p>
                    {{ data?.timezone?.toUpperCase() }}
                  </div>
                </div>

                <div class="expanded-row">
                  <div></div>
                  <div class="details" [style.gridColumn]="getGridColumn(0) + '/ -1'">
                    <p class="expanded-section-label" nz-typography>Scheduler Details</p>
                    {{ data.schedulerDescription }}
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>
</div>

<nz-modal
  [(nzVisible)]="isDeleteModalVisible"
  [nzClosable]="false"
  [nzMaskClosable]="false"
  [nzKeyboard]="false"
  [nzFooter]="modalFooter"
  nzCentered
  nzWrapClassName="edit-query-modal-wrap"
>
  <ng-container *nzModalContent>
    <div class="edit-modal-content">
      <div class="edit-modal-icon-wrap">
        <span nz-icon nzType="warning" nzTheme="outline" class="edit-modal-icon"></span>
      </div>
      <h3 class="edit-modal-title">Do you want to delete the scheduler?</h3>
      <p class="edit-modal-description">
        The scheduler {{ selectedSchedulerRecord.name }} will be permanently deleted. You may choose to delete all
        queries created by this scheduler, or retain the queries and delete only the scheduler.<br />
        This action cannot be undone.
      </p>
    </div>
  </ng-container>

  <ng-template #modalFooter>
    <div class="edit-modal-footer">
      <button nz-button nzType="default" class="cancel-schedule-btn disabled-btn" (click)="closeScheduleModal()">
        Cancel
      </button>
      <button
        nz-button
        nzType="default"
        class="delete-only-scheduler-btn disabled-btn"
        [nzLoading]="scheduleOnlyDeleteLoading"
        (click)="deleteSchedule('SCHEDULER_ONLY')"
      >
        Delete Scheduler Only
      </button>
      <button
        nz-button
        nzType="primary"
        nzDanger
        class="delete-scheduler-query-btn disabled-btn"
        [nzLoading]="schedulerAndQueryDeleteLoading"
        (click)="deleteSchedule('SCHEDULER_AND_QUERY')"
      >
        Delete Scheduler and Queries
      </button>
    </div>
  </ng-template>
</nz-modal>
